import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import TermsAndCondition from "../components/termsAndCondition/termsAndCondition";
import {
  saveAccept,
  SAVE_TANDC_ACCEPT_IN_PROGRESS,
  SAVE_TANDC_ACCEPT_SUCCESS
} from "../actions/termsAndConditions.action";
import { ROUTE_TERMS_AND_CONDITIONS } from "./RouteConstants";

class TermsAndConditionPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAccepted: false
    };

    this.save = this.save.bind(this);
  }

  save() {
    this.props.saveAccept();
  }

  render() {
    if (this.props.saveState === SAVE_TANDC_ACCEPT_SUCCESS) {
      return <Redirect to={"/next-step" + ROUTE_TERMS_AND_CONDITIONS} />;
    }

    const isSaveInProgress =
      this.props.saveState === SAVE_TANDC_ACCEPT_IN_PROGRESS;

    return (
      <div className="container-bg">
        <TermsAndCondition
          saveAccept={this.save}
          isSaveInProgress={isSaveInProgress}
        />
      </div>
    );
  }
}

const mapStateToProps = function(state) {
  return {
    saveState: state.termsConditions.saveState
  };
};

// mapDispatchToProps can just be a plain object. It doesn’t have to be a function.
// rather call it “actionCreators”
const mapDispatchToProps = {
  saveAccept
  // if actions do need arguments, then just wrap those specific action creators in a function eg.
  // saveAccept: () => saveAccept(false),
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TermsAndConditionPage)
);
